import React from "react";
import "./session-out.css";
import session_expired from "./session out.jpeg";
import { PiSmileySadLight } from "react-icons/pi";

function SessionOut() {
  return (
    <>
      <div className="main_div">
        <div className="image_div">
          <div
            class="alert alert-info alert-success credits center"
            role="alert"
          >
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>

            <div class="row margin-t-10">
              <div class="col-md-3 col-xs-5 col1 center-block">
                <div className="alert_message">
                  <strong className="text-center text-danger text-capitalize">
                    Session has expired
                  </strong>

                  <h2 className="text-center mt-10 ">
                    Please don't refresh the page , Don't worry , we kept all of
                    your filters and breakdown in place
                  </h2>

                  <div className="banner-image">
                    <PiSmileySadLight size={100} />
                  </div>
                </div>

                <a href="#">
                  <button class="button btn-success btn-block">
                    <span
                      style={{ fontSize: "17px" }}
                      aria-hidden="true"
                    ></span>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SessionOut;
